import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chat-toggle',
  imports: [],
  templateUrl: './chat-toggle.component.html',
  styleUrl: './chat-toggle.component.scss'
})
export class ChatToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() gap = '16px';

  // Accessible labeling
  @Input() ariaLabel?: string;
  @Input() ariaLabelledby?: string;
  @Input() ariaDescribedby?: string;

  // Emits on change
  @Output() checkedChange = new EventEmitter<boolean>();
  @Output() toggled = new EventEmitter<boolean>();

  onChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.checked = input.checked;
    this.checkedChange.emit(this.checked);
    this.toggled.emit(this.checked);
  }
}
